import { ServiceName } from "../interfaces/serviceName"

import { ServiceNameMap } from "./service"

// 公開日まで隠すためのフラグ。CRA は REACT_APP_* をビルド時に埋め込むので、
// 切り替えるには環境変数を変えて**再ビルド・再デプロイ**が要る（ランタイムでは変わらない）。
// 未設定は OFF。"true" という文字列のときだけ ON にする（REACT_APP_DISABLED_FIGMA と同じ読み方）。

// CLOUD のプラン一覧（プランの選択・変更）を出すか（2-16 / #400）。
// 案C の公開日（10/16）に ON にする。CMS は関係なく常に出す。
export const isCloudPlanPurchaseEnabled = (): boolean =>
  process.env.REACT_APP_CLOUD_PLAN_PURCHASE_ENABLED === "true"

// そのサービスでプランを選べるか。プラン一覧（PlanList）と、URL の ?plan_type= から
// 購入確認を開く経路（usePurchaseModal.openPlanPurchaseModal）の両方がここを見る。
// 片方だけ隠すと、公開前でも URL を知っていれば CLOUD のプランを申し込める。
export const isPlanSelectionEnabled = (serviceName: ServiceName): boolean =>
  serviceName !== ServiceNameMap.CLOUD || isCloudPlanPurchaseEnabled()
